import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/a74133a1-e95c-4d5c-b807-d06a0fea2147";
export const REGISTER_URL = "https://a.ntrk2.com/4d488d56-b541-41fc-857b-ed02d6539b15";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowwinph.kzw2a.com/download?openExternalBrowser=1&id=v02au75axy8g463";

export * from "./codes";
export * from "./context";
